import React from 'react'
import { ControlledSwitch, ControlledSwitchProps } from 'components/ui/ControlledSwitch'
import { useInlineSettings } from '../TaskCreation/contexts/InlineSettingsContext'
import { useBuilderWidget } from '../TaskCreation/contexts/BuilderWidgetContext'

export const ControlledCustomSwitch: React.FC<ControlledSwitchProps> = (props) => {
  const builder = useBuilderWidget()
  const inlineSettings = useInlineSettings()

  return (
    <ControlledSwitch
      activeColor={builder || inlineSettings ? '#222222' : undefined}
      {...props}
      size={builder ? 'md' : props.size || 'sm'}
    />
  )
}
